import { AU, GB, IN, ZA } from '@clearscore/config.i18n';

const statesMappingIndia = {
    andaman_and_nicobar_islands: 'Andaman and Nicobar Islands',
    andhra_pradesh: 'Andhra Pradesh',
    arunachal_pradesh: 'Arunachal Pradesh',
    assam: 'Assam',
    bihar: 'Bihar',
    chandigarh: 'Chandigarh',
    chhattisgarh: 'Chhattisgarh',
    dadara_and_nagar_haveli: 'Dadara and Nagar Haveli',
    daman_and_diu: 'Daman and Diu',
    delhi: 'Delhi',
    goa: 'Goa',
    gujrat: 'Gujrat',
    harayana: 'Harayana',
    himachal_pradesh: 'Himachal Pradesh',
    jammu_and_kashmir: 'Jammu and Kashmir',
    jharkhand: 'Jharkhand',
    karnataka: 'Karnataka',
    kerala: 'Kerala',
    lakshadweep: 'Lakshadweep',
    madhya_pradesh: 'Madhya Pradesh',
    maharashtra: 'Maharashtra',
    manipur: 'Manipur',
    meghalaya: 'Meghalaya',
    mizoram: 'Mizoram',
    nagaland: 'Nagaland',
    orrisa: 'Odisha',
    pondicherry: 'Puducherry',
    punjab: 'Punjab',
    rajasthan: 'Rajasthan',
    sikkim: 'Sikkim',
    tamil_nadu: 'Tamil Nadu',
    telangana: 'Telangan',
    tripura: 'Tripura',
    uttar_pradesh: 'Uttar Pradesh',
    uttranchal: 'Uttarakhand',
    west_bengal: 'West Bengal',
};

function formatAddressParts(addressParts) {
    return addressParts.filter(Boolean).join(', ');
}

export function formatAddress(address, market) {
    const flatOrBuildingNumber = address.flatNumber || address.buildingNumber;
    const streetOrRoad = address.street || address.road;
    const townOrCity = address.town || address.city;
    const countyOrMapping = address.county || statesMappingIndia[address.state];
    const countyOrState = address.county || address.state;
    const postcodeOrPincode = address.postcode || address.pinCode;
    const { currentAddress } = address;

    switch (market) {
        case AU: {
            const noCommasParts = [address.city, address.state, address.postalCode || address.postcode]
                .filter(Boolean)
                .join(' ');
            if (address.flatNumber || address.buildingNumber || address.street) {
                return formatAddressParts([address.flatNumber, address.buildingNumber, address.street, noCommasParts]);
            }
            return formatAddressParts([address.addressLine1, address.addressLine2, noCommasParts]);
        }

        case IN:
            if (currentAddress) {
                return formatAddressParts([currentAddress, townOrCity, countyOrMapping, postcodeOrPincode]);
            }

            return formatAddressParts([
                flatOrBuildingNumber,
                address.buildingName,
                streetOrRoad,
                townOrCity,
                countyOrMapping,
                postcodeOrPincode,
            ]);

        case ZA:
            return formatAddressParts([
                address.flatNumber,
                address.buildingNumber,
                address.buildingName,
                streetOrRoad,
                townOrCity,
                countyOrState,
                postcodeOrPincode,
            ]);

        case GB:
        default:
            return formatAddressParts([
                address.abodeNumber,
                flatOrBuildingNumber,
                address.buildingName,
                streetOrRoad,
                townOrCity,
                countyOrState,
                postcodeOrPincode,
            ]);
    }
}

export default function normalizeAddress(value) {
    if (!value) {
        return value;
    }

    const regex = /[A-Za-z0-9'.\-\s'/,]*/g;
    return value.match(regex).join('');
}
